import { render, staticRenderFns } from "./StudyListContainerView.vue?vue&type=template&id=6c50b5fe&"
import script from "./StudyListContainerView.vue?vue&type=script&lang=js&"
export * from "./StudyListContainerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports